import { LocaleUser } from '../en/user'

const user: LocaleUser = {
  changePass: 'Cambiar contraseña',
  editProfile: 'Editar perfil',
  emailVerifiedSuccess: 'Email verificado con éxito.',
  emailCantVerified: 'No se pudo verificar su Email.',
  changeLang: 'Cambiar idioma',
  english: 'Inglés',
  vietnamese: 'Vietnamita',
  chineseSimplified: 'Chino (simplificado)',
  spanish: 'Español',
  chineseTraditional: 'Chino (tradicional)',
  malay: 'Malayo',
}

export default user
